import { styled } from "@mui/material/styles";

const HorizontalLine = styled("hr")({
  border: 0,
  height: "1px",
  margin: "20px 0",
  background: "rgba(11, 11, 11, 0.25)",
});

export default HorizontalLine;
